import { atom, useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

const EntrySeriesIdsAtom = atom<string[]>([]);

export const useGetEntrySeriesIds = () => {
  return useAtomValue(EntrySeriesIdsAtom);
};

export const useUpdateSeriesId = () => {
  const setSeriesIds = useSetAtom(EntrySeriesIdsAtom);
  const toggleEntry = useCallback(
    (seriesId: string) => {
      setSeriesIds((prev) => {
        if (prev.includes(seriesId)) {
          return prev.filter((id) => id !== seriesId);
        }
        return [...prev, seriesId];
      });
    },
    [setSeriesIds],
  );

  const addEntry = useCallback(
    (seriesId: string) => {
      setSeriesIds((prev) => {
        if (prev.includes(seriesId)) {
          return prev;
        }
        return [...prev, seriesId];
      });
    },
    [setSeriesIds],
  );

  const removeEntry = useCallback(
    (seriesId: string) => {
      setSeriesIds((prev) => {
        if (prev.includes(seriesId)) {
          return prev.filter((id) => id !== seriesId);
        }
        return prev;
      });
    },
    [setSeriesIds],
  );

  // 値がセットされていない初回のみ追加する
  const setInitialEntries = useCallback(
    (seriesIds: string[]) => {
      setSeriesIds((prev) => {
        if (prev.length > 0) {
          return prev;
        }
        return seriesIds;
      });
    },
    [setSeriesIds],
  );

  return {
    setInitialEntries,
    toggleEntry,
    addEntry,
    removeEntry,
  };
};
